import { render, staticRenderFns } from "./AppThankYouBlock.vue?vue&type=template&id=358c3baa&scoped=true"
import script from "./AppThankYouBlock.vue?vue&type=script&lang=js"
export * from "./AppThankYouBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358c3baa",
  null
  
)

export default component.exports